import React from "react";
import { Form, Input, Modal, Button, Grid } from "antd";

const MakePaymentModal = ({ visible, onCancel }) => {
  const [form] = Form.useForm();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handlePayment = (values) => {
    console.log("Payment values:", values);
    // Handle payment logic here
    onCancel();
  };

  return (
    <Modal
      title="Make Payment"
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width={isMobile ? "90%" : 520}
    >
      <Form form={form} layout="vertical" onFinish={handlePayment}>
        <Form.Item
          label="Amount"
          name="amount"
          rules={[{ required: true, message: "Please enter the amount!" }]}
        >
          <Input prefix="K" type="number" />
        </Form.Item>

        <Form.Item
          label="Payment Method"
          name="paymentMethod"
          rules={[
            { required: true, message: "Please select a payment method!" },
          ]}
        >
          <Input placeholder="e.g., Mobile Money, Bank Transfer" />
        </Form.Item>

        <Form.Item
          label="Reference Number"
          name="referenceNumber"
          rules={[
            { required: true, message: "Please enter a reference number!" },
          ]}
        >
          <Input placeholder="e.g., Transaction ID" />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block>
            Submit Payment
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default MakePaymentModal;
